// extracted by mini-css-extract-plugin
module.exports = {"pageInfo":"PageInfo-module--pageInfo--3wJg8","pageInfoItem":"PageInfo-module--pageInfoItem--3_00v","pageInfoContent":"PageInfo-module--pageInfoContent--1JBWk"};